import { useAtomValue } from "@effect/atom-react";
import { RegimePublications } from "@repo/shared/regimePublications";
import * as Effect from "effect/Effect";
import * as Schema from "effect/Schema";
import { AsyncResult, Atom } from "effect/unstable/reactivity";
import { useCallback } from "react";
import { resolvePrimaryEnvironmentHttpUrl } from "../environments/primary/target";
import { appAtomRegistry } from "../rpc/atomRegistry";
import { fetchComplianceJson } from "./complianceFetch";
import { complianceQueryAtom } from "./complianceLive";

export const regimePublicationsAtom = Atom.family((key: string) => {
  const [organizationId, regimeId] = JSON.parse(key) as [string, string];
  return complianceQueryAtom(
    organizationId,
    !organizationId || !regimeId
      ? Effect.succeed(null)
      : fetchComplianceJson(
          resolvePrimaryEnvironmentHttpUrl(
            "/api/amoreg/regulation/regime-publications",
            {
              organizationId,
              regimeId,
            },
          ),
          Schema.decodeUnknownEffect(RegimePublications),
        ),
  );
});

export function useRegimePublications(
  organizationId: string | null,
  regimeId: string,
) {
  const atom = regimePublicationsAtom(
    JSON.stringify([organizationId ?? "", regimeId]),
  );
  const result = useAtomValue(atom);
  const value = AsyncResult.value(result);
  const data = value._tag === "Some" ? value.value : null;
  const failed = result._tag === "Failure" || !!(data && "unavailable" in data);
  const snapshot = data && !("unavailable" in data) ? data : null;
  const refresh = useCallback(() => appAtomRegistry.refresh(atom), [atom]);
  return { snapshot, failed, isPending: result.waiting, refresh };
}
